<template>
    <v-row>
        <v-col cols="12" v-for="order in orderInitialProducts" :key="order.seller.id">
            <order-card
                :order="order"
                @delete-product="deleteProduct"
                @update-basket="updateBasket"
            ></order-card>
        </v-col>
        <v-col>
            <v-skeleton-loader
                v-if="isLoading"
                type="image, article"
                v-for="i in 3" :key="i"
                class="mx-auto md-4 mb-12"
                width="95%"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" v-if="showEmptyMessage">
            <div class="title py-8 text-center">{{ $t('basketEmpty') }}</div>
        </v-col>
    </v-row>
</template>

<script>
    import OrderCard from './OrderCard';
    import Auth from "../../../../app-front/mixins/Auth";
    import NoLoginBasket from "../../../../app-front/mixins/NoLoginBasket";
    import OrderDataProvider from '../../../../app-front/mixins/OrderDataProvider';

export default {
    name: "OrderList",
    mixins: [
        Auth,
        NoLoginBasket,
        OrderDataProvider,
    ],
    components: {OrderCard},
    data() {
        return {
            withoutReload: false,
            isLoading: true
        }
    },
    computed: {
        showEmptyMessage() {
            return !this.isLoading && !this.orderInitialProducts.length;
        },
        productData() {
            return this.$store.state.basket.items;
        },
    },
    methods: {
        setBasketData() {
            if(this.isUserLoggedIn) {
                this.setLoginBasketData();
            } else {
                this.setNoLoginBasketData();
            }
        },
        setLoginBasketData() {
            const items = this.basketItems;
            if (!items || !items.length) {
                this.isLoading = false;
                return false;
            }
            this.basketService.products()
                .then(res => {
                    this.setOrderProducts(res.data);
                    this.isLoading = false;
                })
                .catch(err => console.log(err))

        },
        setNoLoginBasketData() {
            const items = this.noLoginBasketItems;
            if (!items || !items.length) {
                this.isLoading = false;
                return false;
            }
            const IDs = items.map(item=> item.id);
            this.basketService.guestProducts(IDs)
                .then(res => {
                    this.setOrderProducts(res.data);
                    this.isLoading = false;
                })
                .catch(err => console.log(err))
        },
        deleteProduct(data) {
            if(this.isUserLoggedIn) {
                this.withoutReload = true;
                this.basketService.deleteProduct(data.productID)
                    .then(res => {
                        this.$store.commit('deleteBasketItems', [res.id])
                        this.isLoading = false;
                    })
                    .catch(err => console.log(err));
            } else {
                this.withoutReload = true;
                this.deleteProductFromNoLoginBasket(data.productID)
            }
        },
        updateBasket(data){
            if(this.isUserLoggedIn) {
                this.withoutReload = true;
                this.basketService.updateList([data])
                    .then(res => {
                        this.$store.commit('setBasket', res.data);
                        this.isLoading = false;
                    })
                    .catch(err => console.log(err));
            } else {
                const product = {
                    id: data.id,
                    quantity: data.quantity
                }
                this.updateNoLoginBasket(product)
            }
        },
        isLoadingData() {
            if (this.productData.length) {
                this.isLoading = false;
            }
        }
    },
    created() {

        this.setBasketData()
    },
    watch: {
        basketItemsProducts() {
            this.setBasketData();
        },
        noLoginBasketItems() {
            this.setBasketData();
        }
    }
}
</script>
